/*
 * Copyright (c) 2024. Tooling Team
 */

import PropTypes from "prop-types";
import { useMemo } from "react";
import AttributeFilter from "./attributeFilter";
import { Button } from "@uhg-abyss/web/ui/Button";
import { useSelector } from "react-redux";
import { SelectInput } from "@uhg-abyss/web/ui/SelectInput";
import { useGetClientListQuery } from "../app/services/clientApi";
import { getClientNameDropdownValues } from "../utils/clientDropdown";

export default function MapLookupContainer(props) {
  const { attrLoading, attrFilters } = useSelector((state) => state.map || {});
  const { data: clientListResponse } = useGetClientListQuery();
  const clientDropdownValues = useMemo(() => {
    return getClientNameDropdownValues(clientListResponse);
  }, [clientListResponse]);

  return (
    <>
      {attrLoading ? (
        <div className="row align-items-start m-3">
          <div className="col-2">
            <div className="dropdowns">
              <label>{"Map Lookup"}</label>
              <SelectInput
                placeholder="Loading, Please wait..."
                isDisabled={true}
              />
            </div>
          </div>
        </div>
      ) : (
        <div className="row align-items-start">
          {attrFilters.map((filter) => (
            <AttributeFilter
              key={filter._id}
              isSearchDisabled={props.isSearchDisabled}
              filter={filter}
              onFilterChange={props.handleFilterChange}
              newMapLocation={props.newMapLocation}
              selectedDomain={props.selectedDomain}
              cloneTo={props.cloneTo}
              clientOptions={clientDropdownValues}
            />
          ))}
          <div className="col mt-auto">
            <Button
              type="submit"
              color="primary"
              onClick={() => props.handleMapSearch("MAX")} //initial search wants MAX version
              isDisabled={props.isSearchBtnDisabled}
            >
              Search
            </Button>
          </div>
        </div>
      )}
    </>
  );
}

MapLookupContainer.propTypes = {
  newMapLocation: PropTypes.object,
  selectedDomain: PropTypes.string,
  cloneTo: PropTypes.object,
  isSearchBtnDisabled: PropTypes.bool,
  isSearchDisabled: PropTypes.bool,
  handleMapSearch: PropTypes.func,
  handleFilterChange: PropTypes.func,
};
